import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	List,
	ListItem,
	ListItemButton,
	ListItemText,
} from "@mui/material"
import { formatLicenseNumber } from "../util/helpers"

const SimilarPostsDialog = ({
	setPostPriceScore,
	setPostPriceScoreMin,
	setPostPriceScoreMax,
	setPostPriceScoreValues,
	setSavePriceScoreValues,
	similarPostsDialog,
	setSimilarPostsDialog,
	similarPosts,
	setSimilarPosts,
}) => {
	const handleSimilarPostsDialogClose = () => {
		setSimilarPostsDialog(false)
		setSimilarPosts([])
	}

	const handleChoosePost = (post) => {
		setPostPriceScoreValues(post.priceScoreValues)
		setPostPriceScore(post.priceScore)
		setPostPriceScoreMax(post.priceScoreMax)
		setPostPriceScoreMin(post.priceScoreMin)
		setSavePriceScoreValues(true)
		handleSimilarPostsDialogClose()
	}

	return (
		<Dialog open={similarPostsDialog} onClose={handleSimilarPostsDialogClose}>
			<DialogTitle>{"שכפול מידע דירוג מחיר"}</DialogTitle>
			<DialogContent>
				<DialogContentText>נמצאו {similarPosts.length} מודעות דומות</DialogContentText>
				<List>
					{similarPosts.map((post) => (
						<ListItem disablePadding key={post.id}>
							<ListItemButton sx={{ backgroundColor: "grey" }} onClick={() => handleChoosePost(post)}>
								<ListItemText primary={formatLicenseNumber(post.licenseNumber)} />
								&nbsp;
								<ListItemText primary={`יד: ${post.previousOwners}`} />
								&nbsp;
								<ListItemText primary={`קילומטרז: ${post.odometer}`} />
							</ListItemButton>
						</ListItem>
					))}
				</List>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleSimilarPostsDialogClose}>ביטול</Button>
				{/* <Button onClick={() => handleOk()} autoFocus>
					המשך
				</Button> */}
			</DialogActions>
		</Dialog>
	)
}

export default SimilarPostsDialog
